import React, { Component } from 'react';
import loadScripts  from '../../dassets/js/custom';
import api from '../api';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import store from "../redux/store";

class Careers extends Component {
  constructor(props) {
    super(props);

    this.state = {
        jobs: [],
    }
  }

  componentDidMount() {
    loadScripts();
    this.fetchJobs();
  }

  fetchJobs() {
    api.get(`/getJobs`)
    .then(response => {
        this.setState({
            jobs: response.data.data,
        });
    }).catch(error => {
        let err = store.getState().error;
        if (err) {
            toast.error(err.message);
            this.props.history.push(err.redirectUrl)
        }
        console.log(error)
    });
  }

  render() {
    return (
      <>
      {/* =================================
    Inner Header */}
    <div className="inner-header bg-light">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-sm-6 text-sm-start mb-2 mb-sm-0">
            <h1 className="breadcrumb-title mb-0">Careers</h1>
          </div>
          <div className="col-sm-6">
            <ol className="breadcrumb d-flex justify-content-center justify-content-sm-end ms-auto">
              <li className="breadcrumb-item"><Link to={"/"}><i className="fas fa-home me-1"></i>Home</Link></li>
              <li className="breadcrumb-item active"><span>Careers</span></li>
            </ol>
          </div>
        </div>
      </div>
    </div>
  {/* =================================
  Inner Header */}

  

{/* <!--=================================
  You Tube --> */}
  <section className="space-ptb mb-2">
    <div className="container">
      <div className="row">
        {/* <div className="col-lg-6">
          <div className="you-tube mb-4 mb-lg-0">
            <img className="img-fluid" src={require("../../dassets/images/career.svg")} alt="" />
          </div>
        </div> */}
        <div className="col-lg-12">
          <h4>We Do Awesome Work And Build Amazing Teams. Join Us Today!</h4>
          <p>Dynamic Portfolio is committed to providing ways for employees to learn and grow at every stage of their careers. As an experienced employee in our team, we offer you a dynamic environment that welcomes your wealth of knowledge and ensures you never stop learning and growing as an individual.</p>
          <p>As a fresh graduate, your foundational experience always plays a key role in the future of your career. At Dynamic Portfolio, the entirety of our essence is embedded in growth. We make it a priority to provide growth for great minds like yours, who are committed to improving the world. We open our doors to you to ensure you are equipped with the right and necessary steps for the successful career you desire.</p>
          <p>We are glad you have shown interest to work with us. Please, find below the current openings and apply for whichever one suits your profile. </p>
        </div>
      </div>
    </div>
  </section>
  {/* <!--=================================
  You Tube --> */}

  {/* <!--=================================
  Feature Info --> */}
  {/* <section className="space-ptb mb-3">
    <div className="container">
      <div className="row">
        <div className="col-md-12">
          <div className="section-title text-center">
            <h4>Here Are Just A Some Of The Reasons You Will Love It Here.</h4>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-md-4 mb-md-0 mb-4 text-center">
          <div className="feature-info feature-info-style-1">
            <div className="feature-info-icon">
              <i className="flaticon-money"></i>
            </div>
            <div className="feature-info-content">
              <h6 className="feature-info-title">Flexible Time Off </h6>
              <p>Do it today. Remind yourself of someone you know who died suddenly and the fact that there is no guarantee that.</p>
            </div>
          </div>
        </div>
        <div className="col-md-4 mb-md-0 mb-4 text-center">
          <div className="feature-info feature-info-style-1">
            <div className="feature-info-icon">
              <i className="flaticon-research-1"></i>
            </div>
            <div className="feature-info-content">
              <h6 className="feature-info-title">Parental Leave </h6>
              <p>Having clarity of purpose and a clear picture of what you desire is probably the single most important.</p>
            </div>
          </div>
        </div>
        <div className="col-md-4 mb-md-0 mb-4 text-center">
          <div className="feature-info feature-info-style-1">
            <div className="feature-info-icon">
              <i className="flaticon-team"></i>
            </div>
            <div className="feature-info-content">
              <h6 className="feature-info-title">Fitness Cash </h6>
              <p>Make a list of your achievements toward your long-term goal and remind yourself that intentions don’t count, only actions.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section> */}
  {/* <!--=================================
  Feature Info --> */}

  {/* <!--=================================
  Feature Info --> */}
  <section className="space-ptb">
    <div className="container">
      <div className="row justify-content-center">
        <div className="col-md-8">
          <div className="section-title text-center">
            <h4>Current Openings</h4>
          </div>
        </div>
      </div>

      {this.state.jobs.length > 0 ? this.state.jobs.map((job,i) => {
      return <div key={i} className="row justify-content-center">
        <div className="col-lg-8 col-md-10">
          <div className="accordion accordion-style-2" id="accordion-item-2">
            <div className="card">
              <div className="accordion-icon card-header" id="one-accordion-item-2">
                <h6 className="mb-0">
                <button className="btn" data-bs-toggle="collapse" type="button" data-bs-target="#collapse-one-accordion-item-2" aria-expanded="true" aria-controls="collapse-one-accordion-item-2">
                  {job.title}
                </button>
                </h6>
              </div>
              <div id="collapse-one-accordion-item-2" className="collapse show" aria-labelledby="one-accordion-item-2" data-bs-parent="#accordion-item-2">
                <div className="card-body">
                <span dangerouslySetInnerHTML={{ __html: job.description }} />
                  <span>Send Applications to <strong><a href={`mailto:${job.email}`}>{job.email}</a></strong> with <strong>{job.title}</strong> as the subject.</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      }) : <p className='text-center'>There are currently no openings. Please check back as we update any available openings on this website from time to time.</p>}
    </div>
  </section>
  {/* <!--=================================
  Feature Info --> */}
  
      </>
    );
  }
}

export default Careers